import { Alert } from '@recipes/ui';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useAiUnlocked } from '@/features/shared/hooks';

/**
 * Shown where an AI feature cannot be used yet: either an administrator has not unlocked AI
 * for this account (nothing the user can do), or the user has not given consent (profile).
 */
export function AiConsentNotice({
  variant = 'alert',
  className,
}: {
  variant?: 'alert' | 'inline';
  className?: string;
}) {
  const { t } = useTranslation();
  const unlocked = useAiUnlocked();
  const link = unlocked && (
    <Link to="/profile" className="font-medium text-primary underline">
      {t('add.consent.link')}
    </Link>
  );
  if (variant === 'inline')
    return (
      <p className={className ?? 'text-sm text-muted-foreground'} data-testid="ai-consent-notice">
        {t(unlocked ? 'add.consent.short' : 'add.locked.short')} {link}
      </p>
    );
  return (
    <Alert
      variant="info"
      title={t(unlocked ? 'add.consent.title' : 'add.locked.title')}
      className={className ?? 'mb-4'}
      data-testid="ai-consent-notice"
    >
      {t(unlocked ? 'add.consent.body' : 'add.locked.body')} {link}
    </Alert>
  );
}
